import { FC } from 'react';
import { Box } from '@qga/roo-ui/components';
import { ShowOnSmallScreen } from 'components/Layout';
import PropertyImage from 'components/PropertyImage';
import { SelfServiceAPI } from 'types';

interface MobileOnlyPropertyImageProps {
  booking: SelfServiceAPI.Booking;
}

const MobileOnlyPropertyImage: FC<MobileOnlyPropertyImageProps> = ({ booking }) => {
  return (
    <ShowOnSmallScreen>
      <Box>
        <PropertyImage {...booking.mediumImage} />
      </Box>
    </ShowOnSmallScreen>
  );
};

export default MobileOnlyPropertyImage;
